import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import apiClient from "utils/apiClient";

const AVATAR_COLORS = ["#4F46E5","#0EA5E9","#10B981","#F59E0B","#EF4444","#8B5CF6","#EC4899","#14B8A6"];

const faqs = [
  { q: "Bagaimana cara membuat tenant baru?", a: "Masuk ke menu Master Tenant, klik tombol \"Create Tenant\" di pojok kanan atas, lalu isi form wizard 4 langkah: Tenant Info, PIC Details, Contacts, dan Package." },
  { q: "Bagaimana cara mengedit subscription tenant?", a: "Buka detail tenant, klik \"Edit Tenant\", lalu pada Step 4 (Package) Anda bisa mengubah tanggal mulai, tanggal berakhir, grace period, dan paket." },
  { q: "Apa yang terjadi jika subscription tenant expired?", a: "User pada tenant tersebut tidak bisa login ke LMS EDUNARA. Akan muncul notifikasi bahwa subscription telah kadaluarsa dan diminta untuk menghubungi admin." },
  { q: "Bagaimana cara mengatur menu akses per tenant?", a: "Buka detail tenant, klik \"Setting Menu\" atau akses via menu three dots di Master Tenant. Pilih role, lalu centang menu yang diizinkan." },
  { q: "Bagaimana cara menambah user admin baru?", a: "Masuk ke menu User Management, klik \"Create User\", isi data name, email, dan password. User baru akan langsung bisa login." },
  { q: "Di mana saya bisa melihat riwayat aktivitas?", a: "Masuk ke menu Activity Log di sidebar bagian System. Anda bisa filter berdasarkan sumber (LMS EDUNARA / Tenant), aksi (create/update/delete), dan tenant." },
];

function HelpSupport() {
  const history = useHistory();
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [openFaq, setOpenFaq] = useState(null);
  const [supportEmail, setSupportEmail] = useState("");
  const [appName, setAppName] = useState("LMS Tenant Management");

  useEffect(() => {
    apiClient.get("/users", { params: { per_page: 100, is_active: true } })
      .then((res) => { if (res.data?.status === "success") setUsers(res.data.data || []); })
      .catch(() => {});

    apiClient.get("/settings")
      .then((res) => {
        if (res.data?.status === "success") {
          const g = res.data.data?.general;
          if (g?.support_email) setSupportEmail(g.support_email);
          if (g?.app_name)      setAppName(g.app_name);
        }
      }).catch(() => {});
  }, []);

  useEffect(() => { document.title = "Help & Support | LMS Tenant"; }, []);

  const activeUsers = users.filter((u) => u.is_active);

  return (
    <div className="lms-page lms-anim-fade">
      {/* Header */}
      <div className="lms-page-header">
        <div className="lms-page-header-text">
          <div className="lms-breadcrumb">
            <span style={{ cursor: "pointer" }} onClick={() => history.push("/admin/dashboard")}>Dashboard</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="12" height="12"><polyline points="9 18 15 12 9 6"/></svg>
            <span className="lms-breadcrumb-current">{t("Help & Support")}</span>
          </div>
          <div className="t-display" style={{ marginTop: 4 }}>{t("Help & Support")}</div>
          <div className="t-small lms-text-muted" style={{ marginTop: 2 }}>{t("Butuh bantuan? Temukan jawaban atau hubungi tim kami")}</div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: 20, alignItems: "start" }}>

        {/* ── Left column ── */}
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

          {/* Hubungi Kami */}
          <div className="lms-card">
            <div className="lms-card-header">
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--brand-50)", color: "var(--brand-500)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
                </div>
                <div>
                  <div className="t-h3">{t("Hubungi Kami")}</div>
                  <div className="t-caption lms-text-muted">{t("Pilih saluran yang paling nyaman untuk Anda")}</div>
                </div>
              </div>
            </div>
            <div className="lms-card-body">
              <div style={{ display: "grid", gridTemplateColumns: supportEmail ? "1fr 1fr" : "1fr", gap: 14 }}>
                {/* Discord */}
                <a
                  href="https://discord.gg/WHAsvSUS"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <div style={{
                    display: "flex", alignItems: "center", gap: 16,
                    padding: "18px 20px", borderRadius: "var(--r-lg)",
                    background: "linear-gradient(135deg, #5865F2 0%, #4752c4 100%)",
                    color: "#fff", cursor: "pointer",
                    boxShadow: "0 4px 14px rgba(88,101,242,0.3)",
                    transition: "transform 0.15s, box-shadow 0.15s",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(88,101,242,0.4)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 4px 14px rgba(88,101,242,0.3)"; }}
                  >
                    <div style={{ width: 44, height: 44, borderRadius: 12, background: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028 14.09 14.09 0 001.226-1.994.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03z"/>
                      </svg>
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 14 }}>{t("Discord Community")}</div>
                      <div style={{ fontSize: 12, opacity: 0.85, marginTop: 2 }}>{t("Chat langsung dengan tim & komunitas")}</div>
                    </div>
                  </div>
                </a>

                {/* Email */}
                {supportEmail && (
                  <a href={`mailto:${supportEmail}`} style={{ textDecoration: "none" }}>
                    <div style={{
                      display: "flex", alignItems: "center", gap: 16,
                      padding: "18px 20px", borderRadius: "var(--r-lg)",
                      background: "var(--brand-50)", border: "1px solid var(--brand-100)",
                      cursor: "pointer", height: "100%",
                      transition: "transform 0.15s, box-shadow 0.15s",
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "var(--shadow-md)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
                    >
                      <div style={{ width: 44, height: 44, borderRadius: 12, background: "var(--brand-100)", color: "var(--brand-600)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                          <polyline points="22,6 12,13 2,6"/>
                        </svg>
                      </div>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 14, color: "var(--brand-700)" }}>{t("Email Support")}</div>
                        <div style={{ fontSize: 12, color: "var(--brand-600)", marginTop: 2 }}>{supportEmail}</div>
                      </div>
                    </div>
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* FAQ */}
          <div className="lms-card">
            <div className="lms-card-header">
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--warning-50)", color: "var(--warning-600)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                </div>
                <div>
                  <div className="t-h3">{t("Pertanyaan Umum")}</div>
                  <div className="t-caption lms-text-muted">{t("{{count}} pertanyaan tersedia", { count: faqs.length })}</div>
                </div>
              </div>
            </div>
            <div style={{ padding: "4px 22px 8px" }}>
              {faqs.map((faq, i) => (
                <div key={i} style={{ borderBottom: i < faqs.length - 1 ? "1px solid var(--border-subtle)" : "none" }}>
                  <button
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    style={{ width: "100%", background: "none", border: "none", cursor: "pointer", padding: "14px 0", display: "flex", justifyContent: "space-between", alignItems: "center", textAlign: "left", gap: 12, fontFamily: "inherit" }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{
                        width: 22, height: 22, borderRadius: 6, flexShrink: 0,
                        background: openFaq === i ? "var(--brand-500)" : "var(--slate-100)",
                        color: openFaq === i ? "#fff" : "var(--text-muted)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 11, fontWeight: 700, transition: "all 0.15s",
                      }}>
                        {i + 1}
                      </span>
                      <span style={{ fontSize: 13.5, fontWeight: 600, color: openFaq === i ? "var(--brand-600)" : "var(--text-strong)", lineHeight: 1.4 }}>
                        {t(faq.q)}
                      </span>
                    </div>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="14" height="14"
                      style={{ flexShrink: 0, color: "var(--text-muted)", transform: openFaq === i ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </button>
                  {openFaq === i && (
                    <div style={{ fontSize: 13.5, color: "var(--text-base)", lineHeight: 1.7, paddingBottom: 14, paddingLeft: 32 }}>
                      {t(faq.a)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Informasi Sistem */}
          <div className="lms-card">
            <div className="lms-card-header">
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--success-50)", color: "var(--success-600)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                </div>
                <div className="t-h3">{t("Informasi Sistem")}</div>
              </div>
            </div>
            <div className="lms-card-body" style={{ paddingTop: 16 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                {[
                  { label: "Versi", value: "v1.0.0", badge: true },
                  { label: "Platform", value: appName },
                  { label: "Last Update", value: "18 Mei 2026" },
                  { label: "Developer", value: "PT Zegen Solusi Mandiri" },
                ].map(({ label, value, badge }) => (
                  <div key={label} style={{ background: "var(--slate-50)", borderRadius: "var(--r-md)", padding: "12px 14px", border: "1px solid var(--border-subtle)" }}>
                    <div className="t-eyebrow" style={{ marginBottom: 4 }}>{t(label)}</div>
                    {badge ? (
                      <span className="lms-badge lms-badge-no-dot lms-badge-success" style={{ fontSize: 13 }}>{value}</span>
                    ) : (
                      <div style={{ fontSize: 13.5, fontWeight: 500, color: "var(--text-strong)" }}>{value}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>

        {/* ── Right column — Tim Kami ── */}
        <div className="lms-card" style={{ position: "sticky", top: 20 }}>
          <div className="lms-card-header">
            <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1 }}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--info-50)", color: "var(--info-600)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
              </div>
              <div className="t-h3">{t("Tim Kami")}</div>
            </div>
            <span className="lms-badge lms-badge-no-dot lms-badge-brand">{t("{{count}} anggota", { count: activeUsers.length })}</span>
          </div>
          <div style={{ overflowY: "auto", maxHeight: "calc(100vh - 260px)" }}>
            {activeUsers.length === 0 ? (
              <div className="lms-empty" style={{ padding: "40px 20px" }}>
                <div className="lms-empty-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
                </div>
                <p className="t-small lms-text-muted">{t("Belum ada anggota tim")}</p>
              </div>
            ) : activeUsers.map((u, i) => {
              const bg = AVATAR_COLORS[(u.name || "").charCodeAt(0) % AVATAR_COLORS.length];
              const initials = (u.name || "U").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
              return (
                <div key={u.id} style={{
                  display: "flex", alignItems: "center", gap: 12,
                  padding: "12px 22px",
                  borderBottom: i < activeUsers.length - 1 ? "1px solid var(--border-subtle)" : "none",
                  transition: "background var(--t-fast)",
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "var(--slate-50)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                >
                  <div style={{
                    width: 38, height: 38, borderRadius: 10, background: bg, flexShrink: 0,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    color: "#fff", fontWeight: 700, fontSize: 13,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                  }}>
                    {initials}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13.5, fontWeight: 600, color: "var(--text-strong)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{u.name}</div>
                    {u.position && (
                      <div style={{ marginTop: 2 }}>
                        <span style={{ fontSize: 11, fontWeight: 600, color: "var(--brand-600)", background: "var(--brand-50)", borderRadius: 4, padding: "1px 6px" }}>{u.position}</span>
                      </div>
                    )}
                    <div className="t-caption lms-text-muted" style={{ marginTop: 3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{u.email}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </div>
  );
}

export default HelpSupport;
